export default __webpack_public_path__ + "static/media/all_project.33d91982.svg";